<template>
  <div>
    <Button v-if="data.length == 0" type="error" @click="add" size="small"
      >添加摄像头</Button
    >
    <Button v-if="false" type="error" @click="must" size="small"
      >检查必填</Button
    >
    <Table border id="mmmtable" :columns="columns" :data="data" height="300">
      <template v-for="(item, iinnde) in columns" #[item.slot]="{ row, index }">
        <div :key="iinnde">
          <Input
            v-if="item.type == 'Input'"
            v-model="data[index][item.slot]"
          ></Input>
          <InputNumber
            v-if="item.type == 'InputNumbher'"
            v-model="data[index][item.slot]"
          ></InputNumber>
          <div v-if="item.type == 'Button'">
            <Button
              size="small"
              @click="add(index)"
              type="success"
              icon="md-add"
            ></Button>
            <Button
              size="small"
              @click="del(index)"
              type="error"
              icon="md-close"
            ></Button>
          </div>
          <lySelect
            v-if="item.type == 'lySelect'"
            :selectItems="item.selectItems"
            style="width: 100%"
            formate="datetime"
            :clearable="false"
            v-model="data[index][item.slot]"
          >
          </lySelect>
          <p
            v-if="
              check && item.required && utils.isEmpty(data[index][item.slot])
            "
          >
            必填
          </p>
        </div>
      </template>
    </Table>
  </div>
</template>
<script>
import lySelect from "../common/lySelect.vue";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [],
      columns: [
        {
          title: "*摄像头名称",
          slot: "name",
          type: "Input",
          required: true,
        },

        {
          title: "SIP用户名",
          slot: "deviceNo",
          type: "Input",
        },
        {
          title: "通道号",
          slot: "channelId",
          type: "Input",
          required: true,
        },
        {
          title: "型号",
          slot: "factory",
          type: "Input",
        },
        {
          title: "路径",
          slot: "url",
          type: "Input",
        },
        {
          title: "设备类型",
          slot: "type",
          //type: "lySelect",
          type: "Input",
          //selectItems: ["老板", "经理", "文秘", "其他"],
        },
        {
          title: "备注",
          slot: "remark",
          type: "Input",
        },

        {
          title: "操作",
          slot: "action",
          type: "Button",
          width: 80,
        },
      ],
      check: false, //用来存没有填写的必填字段的信息，用于检查
    };
  },
  methods: {
    reach(v) {
      return;
      let list = [];
      for (let i = 1; i <= 5; i++) {
        let obj = {
          tagKey: String(i),
          id: 0,
          no: "",
          name: "",
          mark: "",
          type: 0,
          unit: "",
          contact: "",
          deliveryMode: "",
          address: "",
          tel: "",
          pnumber: 0,
          cbm: 0,
          weight: 0,
          number: 0,
          deliveryTime: Date.now() + 3600 * 1000 * 24,
          specPart: "",
          transferStore: "",
          amountRemark: "",
          remark: "",
          keyword: "",
          cellClassName: {
            tel: "red",
            name: "red",
          },
        };
        list.push(obj);
      }
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < v.length; j++) {
          if (list[i].tagKey == v[j].tagKey) {
            list[i] = v[j];
          }
        }
      }
      this.list = list;
    },
    getValue() {
      return this.data;
    },
    sum(key) {
      let list = this.list;
      let a = 0;
      for (let i = 0; i < list.length; i++) {
        a += list[i][key];
      }
      let t = a.toFixed(2);
      return Number(t);
    },
    add(index) {
      let list = this.data;
      let data = list[index];
      if (this.list.length == 0) {
        data = {
          channelId: "",
          deviceNo: "",
          factory: "",
          name: "",
          remark: "",
          type: "",
          url: "",
        };
      }
      data.id = 0;
      list.splice(index, 0, { ...data });
    },
    del(index) {
      //alert(index);
      let list = this.data;
      list.splice(index, 1);
    },
    setCol() {
      let c = this.columns;

      for (let i = 0; i < c.length; i++) {
        if (!c[i].width) {
          //c[i].width=130;
          let width = 130;
          if (c[i].type == "InputNumbher") {
            width = 80;
          }
          this.$set(c[i], "width", width);
        }
        if (c[i].slot) {
          this.$set(c[i], "key", c[i].slot);
        }
      }
      console.log(c);
    },
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        sums[key] = {
          key,
          value: "", //全局字样，为空字符串
        };
        if (index === 0) {
          sums[key] = {
            key,
            value: "合计", //第一列显示字样
          };
        }
        const values = data.map((item) => item[key]);
        //自定义列汇总。只要该列的属性type是input Number就汇总
        if (column.type == "InputNumbher") {
          const v = values.reduce((prev, curr) => {
            return prev + curr;
          }, 0);
          sums[key] = {
            key,
            value: v,
          };
        }
      });
      return sums;
    },
    must() {
      let c = this.columns;
      let keys = [];
      //先把必填的字段存起来
      for (let i = 0; i < c.length; i++) {
        if (c[i].required) {
          keys.push(c[i].slot);
        }
      }

      let list = this.data;
      this.check = false;
      //数据和必填字段对比。一旦发现一个没填，立即跳出循环。改变check状态
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < keys.length; j++) {
          if (this.utils.isEmpty(list[i][keys[j]])) {
            this.check = true;
            break;
          }
        }
      }
      return this.check;
    },
  },
  mounted() {
    //this.reach(this.data);
    //this.setCol();
  },
  watch: {
    /* data() {
            this.reach(this.data);
        } */
  },
};
</script>
<style scoped>
.huowuTable thead {
  background: #4874dc;
  color: #fff;
}

.cost th {
  min-width: 60px;
  text-align: left;
}

.huowuTable td,
.huowuTable th {
  padding-left: 10px;
}
</style>
<style>
#mmmtable {
  overflow: visible !important;
}

#mmmtable .ivu-table th {
  background: #4874dc;
  color: #fff;
}

#mmmtable .ivu-table-header thead tr th {
  padding: 0px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/zhongzz/videoList.vue